(function () {
  function initNqRoninHeaderHero(root) {
    if (!root || root.dataset.nqrhhInit === 'true') return;
    root.dataset.nqrhhInit = 'true';

    if (!document.getElementById('nqrhh-mobile-drawer-fix')) {
      var drawerFix = document.createElement('style');
      drawerFix.id = 'nqrhh-mobile-drawer-fix';
      drawerFix.textContent = [
        '@media (max-width: 990px) {',
        '  .nqrhh-drawer { width: min(86vw, 380px); }',
        '  .nqrhh-drawer-backdrop { cursor: pointer; touch-action: manipulation; }',
        '  .nqrhh-drawer-backdrop:not(.is-active) { pointer-events: none !important; }',
        '  .nqrhh-drawer-backdrop.is-active { pointer-events: auto !important; }',
        '}',
        '@media (max-width: 390px) {',
        '  .nqrhh-drawer { width: 84vw; }',
        '}'
      ].join('\n');
      document.head.appendChild(drawerFix);
    }

    var headerLayer = root.querySelector('.nqrhh-header-layer');
    var triggers = root.querySelectorAll('.nqrhh-category-trigger');
    var mega = root.querySelector('.nqrhh-mega');
    var panels = root.querySelectorAll('.nqrhh-mega-panel');
    var closeMegaTimer = null;

    function openMega(panelId) {
      if (!mega || !panelId) return;
      window.clearTimeout(closeMegaTimer);
      mega.classList.add('is-active');

      triggers.forEach(function (trigger) {
        var isCurrent = trigger.getAttribute('data-panel') === panelId;
        trigger.classList.toggle('is-open', isCurrent);
        trigger.setAttribute('aria-expanded', isCurrent ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-panel') === panelId);
      });
    }

    function closeMega() {
      if (!mega) return;
      closeMegaTimer = window.setTimeout(function () {
        mega.classList.remove('is-active');
        triggers.forEach(function (trigger) {
          trigger.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        });
        panels.forEach(function (panel) { panel.classList.remove('is-active'); });
      }, 150);
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        openMega(trigger.getAttribute('data-panel'));
      });

      trigger.addEventListener('focus', function () {
        openMega(trigger.getAttribute('data-panel'));
      });

      trigger.addEventListener('click', function () {
        var panelId = trigger.getAttribute('data-panel');
        if (mega && mega.classList.contains('is-active') && trigger.classList.contains('is-open')) {
          closeMega();
        } else {
          openMega(panelId);
        }
      });
    });

    if (headerLayer) {
      headerLayer.addEventListener('mouseenter', function () { window.clearTimeout(closeMegaTimer); });
      headerLayer.addEventListener('mouseleave', closeMega);
    }

    var menuBtn = root.querySelector('.nqrhh-mobile-menu-btn');
    var drawer = root.querySelector('.nqrhh-drawer');
    var backdrop = root.querySelector('.nqrhh-drawer-backdrop');
    var drawerClose = root.querySelector('.nqrhh-drawer-close');

    function openDrawer() {
      if (!drawer || !backdrop) return;
      closeMega();
      drawer.classList.add('is-active');
      backdrop.classList.add('is-active');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop.setAttribute('aria-hidden', 'false');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('nqrhh-lock');
      window.setTimeout(function () {
        if (drawerClose) drawerClose.focus({ preventScroll: true });
      }, 40);
    }

    function closeDrawer(restoreFocus) {
      if (!drawer || !backdrop) return;
      drawer.classList.remove('is-active');
      backdrop.classList.remove('is-active');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.setAttribute('aria-hidden', 'true');
      if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('nqrhh-lock');
      if (restoreFocus && menuBtn) menuBtn.focus({ preventScroll: true });
    }

    if (menuBtn) {
      menuBtn.addEventListener('click', function () {
        if (drawer && drawer.classList.contains('is-active')) {
          closeDrawer(false);
        } else {
          openDrawer();
        }
      });
    }
    if (drawerClose) {
      drawerClose.addEventListener('click', function () { closeDrawer(true); });
    }
    if (backdrop) {
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.addEventListener('pointerdown', function (event) {
        event.preventDefault();
        closeDrawer(false);
      });
      backdrop.addEventListener('click', function () { closeDrawer(false); });
    }

    function closeDrawerFromOutside(event) {
      if (!drawer || !drawer.classList.contains('is-active')) return;
      if (drawer.contains(event.target)) return;
      if (menuBtn && menuBtn.contains(event.target)) return;
      closeDrawer(false);
    }

    document.addEventListener('pointerdown', closeDrawerFromOutside, true);
    document.addEventListener('click', closeDrawerFromOutside, true);

    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { closeDrawer(false); });
      });
    }

    root.querySelectorAll('.nqrhh-drawer-category').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        root.querySelectorAll('.nqrhh-drawer-category').forEach(function (other) {
          if (other !== details) other.open = false;
        });
      });
    });

    var slides = root.querySelectorAll('.nqrhh-slide');
    var dots = root.querySelectorAll('.nqrhh-dots button');
    var prev = root.querySelector('.nqrhh-prev');
    var next = root.querySelector('.nqrhh-next');
    var autoplayEnabled = root.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(root.getAttribute('data-autoplay-speed') || '5000', 10);
    var activeIndex = 0;
    var requestedIndex = 0;
    var slideRequest = 0;
    var autoplayTimer = null;

    function loadSlideMedia(index) {
      if (!slides.length) return;
      var slide = slides[(index + slides.length) % slides.length];
      var template = slide.querySelector('template[data-nq-slide-media]');
      if (!template) return slide.querySelector('img');
      var media = template.content.cloneNode(true);
      var image = media.querySelector('img');
      if (image) {
        image.loading = 'eager';
        image.fetchPriority = 'auto';
      }
      template.replaceWith(media);
      return image;
    }

    function showSlide(index) {
      if (!slides.length) return;
      requestedIndex = (index + slides.length) % slides.length;
      var target = requestedIndex;
      var request = ++slideRequest;
      var image = loadSlideMedia(target);
      function activate() {
        if (request !== slideRequest) return;
        activeIndex = target;
        root.removeAttribute('aria-busy');
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === activeIndex);
          slide.setAttribute('aria-hidden', i === activeIndex ? 'false' : 'true');
          slide.inert = i !== activeIndex;
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === activeIndex);
        });
      }
      if (image && image.complete && image.naturalWidth === 0) {
        root.removeAttribute('aria-busy');
        return;
      }
      if (image && !image.complete) {
        root.setAttribute('aria-busy', 'true');
        image.addEventListener('load', activate, { once: true });
        image.addEventListener('error', function () {
          if (request === slideRequest) root.removeAttribute('aria-busy');
        }, { once: true });
      } else {
        activate();
      }
    }

    function stopAutoplay() {
      if (autoplayTimer) window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }

    function startAutoplay() {
      stopAutoplay();
      if (autoplayEnabled && slides.length > 1) {
        autoplayTimer = window.setInterval(function () {
          showSlide(requestedIndex + 1);
        }, Math.max(3000, autoplaySpeed));
      }
    }

    if (prev) {
      prev.addEventListener('mouseenter', function () { loadSlideMedia(activeIndex - 1); });
      prev.addEventListener('focus', function () { loadSlideMedia(activeIndex - 1); });
      prev.addEventListener('click', function () {
        showSlide(requestedIndex - 1);
        startAutoplay();
      });
    }

    if (next) {
      next.addEventListener('mouseenter', function () { loadSlideMedia(activeIndex + 1); });
      next.addEventListener('focus', function () { loadSlideMedia(activeIndex + 1); });
      next.addEventListener('click', function () {
        showSlide(requestedIndex + 1);
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showSlide(parseInt(dot.getAttribute('data-dot'), 10));
        startAutoplay();
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer(true);
        closeMega();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer(true);
        closeMega();
      }
    });

    showSlide(0);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('.nqrhh-root').forEach(initNqRoninHeaderHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.nqrhh-root');
    if (root) initNqRoninHeaderHero(root);
  });
})();


(function () {
  'use strict';

  function initNaqshdarWhatsAppLink(widget) {
    if (!widget || widget.dataset.nqwaReady === 'true') return;
    widget.dataset.nqwaReady = 'true';

    var whatsappLink = widget.querySelector('[data-nqwa-link]');
    if (!whatsappLink) return;

    function refreshWhatsAppLink() {
      var number = widget.getAttribute('data-nqwa-number') || '923323249978';
      var pageType = widget.getAttribute('data-nqwa-page-type');
      var productTitle = widget.getAttribute('data-nqwa-product');
      var message;

      if (pageType === 'product' && productTitle) {
        message = 'Assalam-o-Alaikum Naqshdar, I have a query about ' + productTitle + '. Product link: ' + window.location.href;
      } else {
        message = 'Assalam-o-Alaikum Naqshdar, I would like help with your products. Page: ' + window.location.href;
      }

      whatsappLink.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
    }

    whatsappLink.addEventListener('click', refreshWhatsAppLink);
    refreshWhatsAppLink();
  }

  function initNaqshdarWhatsAppLinks(root) {
    (root || document).querySelectorAll('[data-nqwa-widget]').forEach(initNaqshdarWhatsAppLink);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initNaqshdarWhatsAppLinks(document); });
  } else {
    initNaqshdarWhatsAppLinks(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initNaqshdarWhatsAppLinks(event.target);
  });
})();

